import { Injectable } from '@angular/core';
import { SupabaseDatabaseService } from './supabase-database.service';
import TYPES from '../constants/types';

@Injectable({
  providedIn: 'root'
})
export class UserPsychologistService <UserPsychologist> extends SupabaseDatabaseService<UserPsychologist> {
  
  async getUserPsychologistByUserId(userId: string): Promise<UserPsychologist | null>{
    
    const { data, error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS)
      .select('*, psychologists(*)')
      .eq('user_id', userId)
      .maybeSingle();

    if (error) {
      // O código 'PGRST116' indica que nenhuma linha foi encontrada, o que não é um erro de fato.
      if (error.code === 'PGRST116') {
        return null;
      }
      console.error(`Erro ao buscar por ID em '${TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS}':`, error);
      throw new Error(error.message);
    }
    return data as UserPsychologist;
    
  }

  async getAllPendingUsersPsychologists(psychologistId: string): Promise<UserPsychologist[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS)
    .select(`
      *,
      users(
        id,
        first_name,
        last_name,
        email,
        phone_number
      ),
      psychologists(
        id,
        first_name,
        last_name,
        phone_number
      )
    `)
    .eq('psychologist_id', psychologistId)
    .eq('status', TYPES.DATABASE.STATUS.WAITING_VALIDATION['code']);

    if (error) {
      console.error(`Erro ao buscar PSYCHOLOGISTS pendentes em '${TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as UserPsychologist[]) || [];

  }


  async getActiveUserPsychologist(userId: string): Promise<UserPsychologist>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS)
    .select(`
      *,
      users(
        id,
        first_name,
        last_name,
        email,
        phone_number
      ),
      psychologists(
        id,
        first_name,
        last_name,
        phone_number
      )
    `)
    .eq('user_id', userId)
    .eq('status', TYPES.DATABASE.STATUS.ACTIVE['code'])
    .maybeSingle();
    

    if (error) {
      console.error(`Erro ao buscar PSYCHOLOGISTS pendentes em '${TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as UserPsychologist);

  }

  async getAllActiveUsersPsychologistsByPsychologistId(psychologistId: string): Promise<UserPsychologist[]>{
    const { data, error } = await this.supabase
    .from(TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS)
    .select(`
      *,
      users(
        id,
        first_name,
        last_name,
        email,
        phone_number
      ),
      psychologists(
        id,
        first_name,
        last_name,
        phone_number
      )
    `)
    .eq('psychologist_id', psychologistId)
    .eq('status', TYPES.DATABASE.STATUS.ACTIVE['code']);

    if (error) {
      console.error(`Erro ao buscar USERPSYCHOLOGISTS ativos em '${TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS}':`,
        error);
      throw new Error(error.message);
    }
    
    return (data as UserPsychologist[]) || [];

  }

  async hasReachedLimit(psychologistId: string) {
    const MAX_STARTER_LIMIT = 2;

    const { count, error } = await this.supabase
      .from(TYPES.DATABASE.TABLES.USERS_PSYCHOLOGISTS)
      .select("*", { count: "exact", head: true })
      .eq("psychologist_id", psychologistId);

    if (error) {
      console.error("Erro ao contar logs:", error);
      throw error;
    }

    return (count ?? 0) >=  MAX_STARTER_LIMIT;
  }

}
